import * as THREE from 'three'

export default {
  uniforms: {
    tDiffuse: { type: 't', value: 0, texture: null }, // The base scene buffer
    center: { type: 'v2', value: new THREE.Vector2(0.5, 0.5) },
    resolution: { type: 'v2', value: new THREE.Vector2(window.innerWidth, window.innerHeight) },
    strength: { type: 'f', value: 0.1 },
    mix: { type: 'f', value: 0.3 }
  },

  vertexShader: `
    varying vec2 vUv;

    void main() {

    vUv = vec2( uv.x, uv.y );
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

    }
  `,

  fragmentShader: `
    uniform sampler2D tDiffuse;
    uniform vec2 center;
    uniform float strength;
    uniform float mix;
    uniform vec2 resolution;
    varying vec2 vUv;

    float random(vec3 scale,float seed){return fract(sin(dot(gl_FragCoord.xyz+seed,scale))*43758.5453+seed);}

    // Gradient noise from Jorge Jimenez's presentation:
    // http://www.iryoku.com/next-generation-post-processing-in-call-of-duty-advanced-warfare
    float gradientNoise(vec2 uv)
    {
        const vec3 magic = vec3(0.06711056, 0.00583715, 52.9829189);
        return fract(magic.z * fract(dot(uv, magic.xy)));
    }

    void main() {

      vec4 color = vec4(0.0);
      float total = 0.0;
      vec2 toCenter = ( center - vUv ) * resolution;

      /* randomize the lookup values to hide the fixed number of samples */
      float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);

      for (float t = 0.0; t <= 40.0; t++) {
        float percent = (t + offset) / 40.0;
        float weight = 4.0 * (percent - percent * percent);
        vec4 texSample = texture2D(tDiffuse, vUv + toCenter * percent / resolution);

        texSample.rgb *= strength;
        /* switch to pre-multiplied alpha to correctly blur transparent images */
        texSample.rgb *= texSample.a;

        color += texSample * weight;
        total += weight;
      }

      vec4 diffuseColor = texture2D( tDiffuse, vUv );

      gl_FragColor = diffuseColor + color*color / total * mix;

      //gl_FragColor += (1.0/255.0) * gradientNoise(gl_FragCoord.xy) - (0.5/255.0);

      

    }
  `
}
